import { AngleKey, FormatKey } from '../insight/insightTypes';
import { PovData } from '../insight/insightTypes';

export enum LibraryActionTypes {
  API_RESPONSE_SUCCESS = '@@library/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR   = '@@library/API_RESPONSE_ERROR',
  FETCH_INSIGHTS       = '@@library/FETCH_INSIGHTS',
  FETCH_INSIGHT_BY_ID  = '@@library/FETCH_INSIGHT_BY_ID',
  DELETE_INSIGHT       = '@@library/DELETE_INSIGHT',
  SET_PAGE             = '@@library/SET_PAGE',
}

export interface InsightCard {
  id: string;
  rawThought: string;
  distilledInsight: string;
  topic: string;
  toneTags: string[];
  hook: string;
  angle: AngleKey;
  packId: string;
  createdAt: string;
}

export interface InsightCardFull extends InsightCard {
  pov: PovData | null;
  outputs: Record<FormatKey, string>;
  feedback: Partial<Record<FormatKey, 'up' | 'down'>>;
}

export interface LibraryState {
  items: InsightCard[];
  total: number;
  page: number;
  pageSize: number;
  isLoading: boolean;
  error: string | null;
}
